import { render } from "./stage3.vue?vue&type=template&id=3e587ec5&scoped=true"
import script from "./stage3.vue?vue&type=script&lang=js"
export * from "./stage3.vue?vue&type=script&lang=js"

import "./stage3.vue?vue&type=style&index=0&id=3e587ec5&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/_DKRx8o2/0/web/speechki_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e587ec5"]])

export default __exports__